var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('router-view',{class:_vm.typeTitle == true?'con-bianyi':'con'}),_c('footerBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }